import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, unref as _unref, resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, resolveDirective as _resolveDirective, withDirectives as _withDirectives, createTextVNode as _createTextVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { style: {"display":"flex","flex-direction":"column","align-items":"center"} }
const _hoisted_2 = { class: "mx-auto mt-[20px] justify-center" }
const _hoisted_3 = { style: {"display":"flex","align-items":"center"} }
const _hoisted_4 = ["src"]

import { ref, computed, onMounted } from "vue";
import { imageCaptcha, oauthLogin, designLoginVerification } from "@/api/oauth";
import { ElMessage } from "element-plus";
import { useUserStore } from "@/stores/user";

import { Message, Lock } from "@element-plus/icons-vue";
import { useRouter, useRoute } from "vue-router";

export default /*@__PURE__*/_defineComponent({
  __name: 'login',
  setup(__props) {

const router = useRouter();
const route = useRoute()
const userStore = useUserStore();
const dialogVisible = ref(false);
const windowWidth = ref(window.innerWidth);
const dialogWidth = computed(() =>
  windowWidth.value * 0.35 > 500 ? windowWidth.value * 0.35 : 500
);
const ruleForm = ref({
  email: "",
  password: "",
  captcha: "",
});
const loginCaptchaImage = ref("");
const loginCaptchaLoading = ref(false);
const getOauthCaptcha = async () => {
  loginCaptchaLoading.value = true;
  const result = await imageCaptcha();
  if (result.data.code === 200) {
    loginCaptchaImage.value = "data:image/png;base64," + result.data.data.image;
    loginCaptchaLoading.value = false;
  }
};
const closeLogin = () => {
  dialogVisible.value = false;
};
onMounted(() => {
  if (route.query.key) {
    LoginVerification()
  } else {
    dialogVisible.value = true;
  }
  getOauthCaptcha();
});
const handleLogin = async () => {
  const result = await oauthLogin(ruleForm.value);
  if (result.data.code === 200) {
    const userResult = result.data.data;
    userStore.setAuthData(userResult);
    ElMessage.success("登录成功");
    dialogVisible.value = false;
    router.push(
      {
        path: "/editor",
        query: { mode: 'user', id: route.query.id, create_tag: route.query['create_tag'] == '1' ? 1 : '', order_no: route.query['order_no'], increment_id: route.query.increment_id, now_state: route.query.now_state }
      }
    );
  }
};
const LoginVerification = async () => {
  try {
    const result = await designLoginVerification({ key: route.query.key })
    if (result.data.code == 200) {
      const userResult = result.data.data;
      userStore.setAuthData(userResult);
      dialogVisible.value = false;
      router.push({
        path: `/editor`,
        query: { mode: 'user', id: route.query.id, create_tag: route.query['create_tag'] == '1' ? 1 : '', order_no: route.query['order_no'], increment_id: route.query.increment_id, now_state: route.query.now_state }
      })
    }
  } catch (error) {
    dialogVisible.value = true;
  }
}

return (_ctx: any,_cache: any) => {
  const _component_el_input = _resolveComponent("el-input")!
  const _component_el_form_item = _resolveComponent("el-form-item")!
  const _component_el_button = _resolveComponent("el-button")!
  const _component_el_form = _resolveComponent("el-form")!
  const _component_el_dialog = _resolveComponent("el-dialog")!
  const _directive_loading = _resolveDirective("loading")!

  return (_openBlock(), _createElementBlock("div", null, [
    _createVNode(_component_el_dialog, {
      modelValue: dialogVisible.value,
      "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((dialogVisible).value = $event)),
      width: dialogWidth.value,
      class: "login-dialog",
      "before-close": closeLogin
    }, {
      default: _withCtx(() => [
        _createElementVNode("div", _hoisted_1, [
          _cache[5] || (_cache[5] = _createElementVNode("div", { class: "text-[20px] text-[#222529] font-semibold leading-snug justify-center" }, " 用户登陆", -1)),
          _cache[6] || (_cache[6] = _createElementVNode("div", { class: "text-[12px] mt-[10px] justify-center" }, " 仅用于身份识别，本站不会获取您的任何隐私信息~ ", -1)),
          _createElementVNode("div", _hoisted_2, [
            _createVNode(_component_el_form, {
              ref: "loginFormRef",
              model: ruleForm.value,
              class: "w-[235px]"
            }, {
              default: _withCtx(() => [
                _createVNode(_component_el_form_item, { prop: "email" }, {
                  default: _withCtx(() => [
                    _createVNode(_component_el_input, {
                      type: "email",
                      placeholder: "请输入邮箱",
                      autocomplete: "off",
                      "prefix-icon": _unref(Message),
                      modelValue: ruleForm.value.email,
                      "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((ruleForm.value.email) = $event)),
                      size: "large",
                      class: "input-rounded"
                    }, null, 8, ["prefix-icon", "modelValue"])
                  ]),
                  _: 1
                }),
                _createVNode(_component_el_form_item, { prop: "password" }, {
                  default: _withCtx(() => [
                    _createVNode(_component_el_input, {
                      type: "password",
                      placeholder: "请输入密码",
                      autocomplete: "off",
                      "prefix-icon": _unref(Lock),
                      modelValue: ruleForm.value.password,
                      "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((ruleForm.value.password) = $event)),
                      "show-password": "",
                      size: "large",
                      class: "input-rounded"
                    }, null, 8, ["prefix-icon", "modelValue"])
                  ]),
                  _: 1
                }),
                _createVNode(_component_el_form_item, { class: "captcha" }, {
                  default: _withCtx(() => [
                    _createElementVNode("div", _hoisted_3, [
                      _createVNode(_component_el_input, {
                        style: {"width":"120px","flex":"1"},
                        modelValue: ruleForm.value.captcha,
                        "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((ruleForm.value.captcha) = $event)),
                        size: "large",
                        class: "input-captcha"
                      }, null, 8, ["modelValue"]),
                      _createElementVNode("div", {
                        class: "h-full min-h-40px flex items-center flex-1 border-l-0 border-t-1px border-b-1px border-r-1px border-solid border-gray-300 cursor-pointer rounded-rt-8px rounded-rb-8px rounded-lt-0 rounded-lb-0",
                        onClick: getOauthCaptcha
                      }, [
                        _withDirectives(_createElementVNode("img", {
                          loading: "lazy",
                          src: loginCaptchaImage.value,
                          alt: "captcha",
                          class: "rounded-rt-8px rounded-rb-8px rounded-lt-0 rounded-lb-0"
                        }, null, 8, _hoisted_4), [
                          [_directive_loading, loginCaptchaLoading.value]
                        ])
                      ])
                    ])
                  ]),
                  _: 1
                }),
                _createVNode(_component_el_button, {
                  class: "w-[230px]",
                  type: "primary",
                  onClick: handleLogin,
                  color: "#2a66ff",
                  size: "large",
                  style: {"border-radius":"8px"}
                }, {
                  default: _withCtx(() => [...(_cache[4] || (_cache[4] = [
                    _createTextVNode("登录", -1)
                  ]))]),
                  _: 1
                })
              ]),
              _: 1
            }, 8, ["model"])
          ])
        ])
      ]),
      _: 1
    }, 8, ["modelValue", "width"])
  ]))
}
}

})